import * as yup from 'yup';

import { passwordValidator } from '@mopla/utils';

export const ChangePasswordValidationSchema = yup.object().shape({
	password: passwordValidator(),
	confirmPassword: yup
		.string()
		.oneOf([yup.ref('password')], 'password.passwords_do_not_match')
		.required('password.required'),
});
